import { styled } from 'linaria/react';
import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const MainInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: 1 / 1 / 2 / 2;
  margin-bottom: -24px;
  ${breakpoints.from.largeDesktop} {
    margin-bottom: -40px;
  }
`;
export const mainInfoHead = css`
  margin-bottom: var(--space-250) !important;

  ${breakpoints.from.desktop} {
    margin-bottom: var(--space-300) !important;
  }
`;
export const addressInfo = css`
  margin-bottom: var(--space-150);
  ${breakpoints.only.mobile} {
    margin-top: var(--space-300);
  }
`;
export const metroInfo = css`
  display: flex;
  flex-direction: column;
`;

export const greyContainer = css`
  flex: 1 0 auto;
  margin-right: var(--space-200);
  background-color: var(--background-secondary);
  border: 1px solid var(--control-minor);
  border-radius: var(--rounding-l);

  &:last-child {
    flex-grow: inherit;
    margin-right: var(--space-200);
    overflow: hidden;
    border: none;
  }

  &:first-child {
    margin-left: var(--space-400);
  }
`;

export const smallMap = css`
  width: 208px;
  height: 128px;
  overflow: hidden;
  -webkit-mask-image: -webkit-radial-gradient(circle, #000, #fff);
`;

export const scrollContainer = css`
  position: absolute;
  left: -16px;
  display: flex;
  width: calc(100vw + var(--space-200));
  height: 128px;
  overflow-x: scroll;
  overflow-y: hidden;
`;

export const overScrollContainer = css`
  height: 128px;
  overflow-x: scroll;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    -webkit-appearance: none;
  }
`;

export const storeConveniences = css`
  margin-top: var(--space-300);
  margin-bottom: var(--space-200);
`;

export const criticalNotification = css`
  margin-bottom: var(--space-300);
`;
